import { Component, Input, OnInit } from '@angular/core';
import {
  NgbActiveModal,
  NgbModule,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { AuthService } from '@core/service/auth.service';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { FormDialogComponent as ModalAddClient } from '../../../administration/utilisateur-client/form-dialog/form-dialog.component';
import { PrintService } from '@core/service/print.service';
import { Direction } from '@angular/cdk/bidi';
import Swal from 'sweetalert2';

export interface DialogData {
  id: number;
  action: string;
  item: any;
}

defineLocale('fr', frLocale);

@Component({
  selector: 'app-modal-commade-restau',
  imports: [
    CommonModule,
    FormsModule,
    IntegerFormatPipe,
    NgSelectModule,
    NgbModule,
    BsDatepickerModule,
  ],
  templateUrl: './modal-commade-restau.component.html',
  styleUrl: './modal-commade-restau.component.scss',
})
export class ModalCommadeRestauComponent implements OnInit {
  @Input() data: any;

  action = '';
  itemToSave: any = {};
  isLoading = false;
  user: any;
  title = 'commande restaurant';
  createMessage = '';
  editMessage = '';
  endPoint = 'commande';

  itemsTypeCommande: any[] = [];
  itemsMenuProgramme: any[] = [];
  itemsMenuProgrammeDetail: any[] = [];
  itemsCommandeDetailToSave: any[] = [];

  programme_menu_id: any;
  menu_search = '';

  constructor(
    public activeModal: NgbActiveModal,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private authService: AuthService,
    private localeService: BsLocaleService,
    private printService: PrintService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.itemToSave = { ...this.data };
    this.user = this.authService.getCurrentUser();
    this.localeService.use('fr');
    this.createMessage = 'Vous êtes sur le point de créer une ' + this.title;
    this.editMessage = 'Vous êtes sur le point de modifier une ' + this.title;
    this.getItemsTypeCommande();
    this.getItemsMenuProgramme();
  }

  submit() {}

  // ── Menu grid ─────────────────────────────────────────────────────────────
  get filteredMenus(): any[] {
    if (!this.menu_search) return this.itemsMenuProgrammeDetail;
    const key = this.menu_search.toLowerCase();
    return this.itemsMenuProgrammeDetail.filter((m: any) =>
      (m.menu_libelle || '').toLowerCase().includes(key)
    );
  }

  // ── Cart helpers ──────────────────────────────────────────────────────────
  isInCart(menu: any): boolean {
    return this.itemsCommandeDetailToSave.some(
      (i: any) => i.menu_id === menu.menu_id
    );
  }

  getCartQty(menu: any): number {
    const found = this.itemsCommandeDetailToSave.find(
      (i: any) => i.menu_id === menu.menu_id
    );
    return found ? found.quantite : 0;
  }

  addToCart(menu: any) {
    const existing = this.itemsCommandeDetailToSave.find(
      (i: any) => i.menu_id === menu.menu_id
    );
    if (existing) {
      existing.quantite++;
      existing.total = existing.quantite * existing.prix;
    } else {
      this.itemsCommandeDetailToSave.push({
        menu_id: menu.menu_id,
        menu_libelle: menu.menu_libelle,
        menu_description: menu.menu_description,
        menu_image_url: menu.image_url,
        menu_programme_id: this.programme_menu_id,
        menu_programme_detail_id: menu.id,
        prix: menu.prix,
        menu_prix: menu.prix,
        quantite: 1,
        total: menu.prix,
      });
    }
  }

  incrementCartQty(item: any) {
    item.quantite++;
    item.total = item.quantite * item.prix;
  }

  decrementCartQty(item: any, index: number) {
    if (item.quantite > 1) {
      item.quantite--;
      item.total = item.quantite * item.prix;
    } else {
      this.itemsCommandeDetailToSave.splice(index, 1);
    }
  }

  onCartQtyChange(item: any) {
    if (!item.quantite || item.quantite < 1) item.quantite = 1;
    item.total = item.quantite * item.prix;
  }

  get cartTotal(): number {
    return this.itemsCommandeDetailToSave.reduce(
      (sum: number, i: any) => sum + (i.total || 0),
      0
    );
  }

  // ── API calls ─────────────────────────────────────────────────────────────
  getItemsTypeCommande() {
    this.restClient
      .post('typeCommande/getByCriteria', {
        data: { codification: 'RESTAURANT' },
        index: 0,
        size: 10000,
      })
      .subscribe((res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsTypeCommande = res['items'];
          this.itemToSave.type_commande_id = this.itemsTypeCommande[0]?.id;
        }
      });
  }

  getItemsMenuProgramme() {
    this.restClient
      .post('menuProgramme/getByCriteria', {
        extra_control: [
          { key: 'date_effet', value: new Date(), sign: '<' },
          { key: 'date_fin', value: new Date(), sign: '>' },
        ],
        data: {},
        index: 0,
        size: 10000,
      })
      .subscribe((res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsMenuProgramme = res['items'];
        }
      });
  }

  onSelectMenuProgramme() {
    this.itemsMenuProgrammeDetail = [];
    this.getItemsProgrammeDetail();
  }

  getItemsProgrammeDetail() {
    if (!this.programme_menu_id) return;
    this.restClient
      .post('menuProgrammeDetail/getByCriteria', {
        data: { menu_programme_id: this.programme_menu_id },
        index: 0,
        size: 10000,
      })
      .subscribe((res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsMenuProgrammeDetail = res['items'];
        } else {
          this.itemsMenuProgrammeDetail = [];
        }
      });
  }

  confirmSaveItem(item: any) {
    if (!item.id) item.code = this.generateUniqueString();
    const objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) this.saveItem(objToSave);
    });
  }

  saveItem(item: any) {
    this.isLoading = true;
    let itemAEnregistrer = Object.assign({}, item);

    let montant = 0;
    let quantite = 0;
    if (this.itemsCommandeDetailToSave?.length) {
      itemAEnregistrer.commandeDetail = this.itemsCommandeDetailToSave;
      itemAEnregistrer.commandeDetail.forEach((iae: any) => {
        iae.type_commande_id = this.itemToSave.type_commande_id;
        iae.hebergement_id = this.itemToSave.hebergement_id;
        iae.chambre_id = this.itemToSave.chambre_id;
        iae.client_id = this.itemToSave.client_id;
        montant += iae.total;
        quantite += iae.quantite;
      });
    }

    itemAEnregistrer.quantite = quantite;
    itemAEnregistrer.montant = montant;
    itemAEnregistrer.type_commande_id = this.itemToSave.type_commande_id;
    itemAEnregistrer.nombre = this.itemsCommandeDetailToSave.length;
    itemAEnregistrer.is_client = true;
    if (this.itemToSave.origine) itemAEnregistrer.origine = this.itemToSave.origine;
    const hebergementId = itemAEnregistrer.id;
    itemAEnregistrer.hebergement_id = hebergementId;
    delete itemAEnregistrer.id;

    this.restClient
      .post(this.endPoint + '/create', { datas: [itemAEnregistrer] })
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (!res['hasError']) {
            this.utilities.showNotification(
              'snackbar-success',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
            this.activeModal.close('saved');
            this.onPrintRecuCommande(res['item']);
          } else if (res['status']?.message) {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        },
        () => {
          this.isLoading = false;
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.getMessageEndPointNotAvailble(),
            'bottom',
            'center'
          );
        }
      );
  }

  onPrintFactureHebergement(hebergement_id: any) {
    this.restClient
      .post('pdf/printFactureHebergement', {
        data: { id: hebergement_id },
        index: 0,
        size: 10000,
      })
      .subscribe((res: any) => {
        if (res && res['item'] && !res['hasError']) {
          this.printService.previewPdf(res['item'].link);
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
        }
      });
  }

  openAddClientModal(action: 'add' | 'edit', data?: any) {
    const varDirection: Direction =
      localStorage.getItem('isRtl') === 'true' ? 'rtl' : 'ltr';
    const modalRef = this.modalService.open(ModalAddClient, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result) => {
      if (result && result.id) {
        this.itemToSave.client_id = result.id;
      }
    });
  }

  generateUniqueString() {
    return (
      new Date().getTime().toString() +
      Math.floor(Math.random() * 1000000).toString()
    );
  }

  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  onPrintRecuCommande(item: any) {
    let request = {
      data: {
        id: item.id,
        entite: 'RESTAURANT',
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('pdf/printRecuCommande', request).subscribe(
      (res: any) => {
        if (res && res['item'] && !res['hasError']) {
          this.printService.previewPdf(res['item'].link);
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
        }
      },
      (err) => {}
    );
  }
}
